





















































































































import {
  computed,
  defineComponent,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import { getRenderedHTML } from '@/useStreamingRender';

import {
  createStream,
  updateStream,
  uploadThumbnail,
} from '@/api/index';

import FileInput from '@/components/FileInput.vue';

const numberArr = [1, 2, 3, 4];

const PanelWithStreamEditor = defineComponent({
  components: {
    FileInput,
  },
  props: {
    value: {
      default() {
        return {
          id: -1,
          name: '',
          streamType: 'YOUTUBE',
          streamUrl: '',
          language: 'TH',
          index: 0,
          button: '',
          button_en: '',
          thumbnailUrl: '',
        };
      },
    },
  },
  setup(props: any, { emit }: any) {
    const { route } = useRouter();

    const edited = ref(false);
    const viewThumbnail = ref(false);

    const successModal = ref(null);

    const thumbnail: { url: string; file: null | File } = reactive({
      url: '',
      file: null,
    });
    async function updateThumbnailAction(id: number) {
      uploadThumbnail(thumbnail.file as File, { id });
    }
    function resetState() {
      thumbnail.file = null;
      thumbnail.url = '';
      edited.value = false;
    }
    const computedStreamInput = computed(() => ({
      name: props.value.name,
      stream_type: props.value.streamType,
      stream_url: props.value.streamUrl === '' ? '-' : props.value.streamUrl,
      language: props.value.language,
      order: props.value.order,
      button: props.value.button,
      button_en: props.value.button_en,
    }));
    const form = reactive({
      name: '',
      streamType: 'YOUTUBE',
      streamUrl: '',
      language: 'TH',
      order: '1',
      button: '',
      button_en: '',
      call: async () => {
        if (props.value.id > -1) {
          await updateStream(props.value.id, computedStreamInput.value);
          if (thumbnail.file) await updateThumbnailAction(props.value.id);
        } else {
          const result = await createStream(route.value.params.liveId, computedStreamInput.value);
          if (thumbnail.file) await updateThumbnailAction(result.id);
        }
        emit('done');
        resetState();
      },
      state: {
        value: 'READY',
      },
    });

    watch(() => props.value, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        form.name = newVal.name;
        form.streamType = newVal.streamType;
        form.streamUrl = newVal.streamUrl;
        form.language = newVal.language;
        form.order = newVal.order;
        form.button = newVal.button;
        form.button_en = newVal.button_en;
      }
    });

    const valueChange = (event: any, type: any) => {
      if (type === 'name') emit('input', { ...props.value, name: event });
      else if (type === 'type') emit('input', { ...props.value, streamType: event });
      else if (type === 'url') emit('input', { ...props.value, streamUrl: event });
      else if (type === 'language') emit('input', { ...props.value, language: event });
      else if (type === 'order') emit('input', { ...props.value, order: event });
      else if (type === 'button') emit('input', { ...props.value, button: event });
      else if (type === 'button_en') emit('input', { ...props.value, button_en: event });
      edited.value = true;
    };

    function pendingRemoveStream() {
      emit('remove', props.value.id, props.value.index);
    }

    const computedVideoDisplay = computed(() => {
      const iFrame = getRenderedHTML(props.value.streamType, props.value.streamUrl);
      if (iFrame === 'invalid') return false;
      return iFrame;
    });

    return {
      numberArr,
      computedVideoDisplay,
      viewThumbnail,
      thumbnail,

      edited,
      form,
      successModal,
      valueChange,
      pendingRemoveStream,
    };
  },
});

export default PanelWithStreamEditor;
